/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Kind_Badger_PeekInputs */

const en_swift_kind_badger_peek = /** @type {(inputs: Swift_Kind_Badger_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal name is only visible for administrators`)
};

const de_swift_kind_badger_peek = /** @type {(inputs: Swift_Kind_Badger_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interner Name ist nur für Administratoren sichtbar`)
};

/**
* | output |
* | --- |
* | "Internal name is only visible for administrators" |
*
* @param {Swift_Kind_Badger_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_kind_badger_peek = /** @type {((inputs?: Swift_Kind_Badger_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Kind_Badger_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_kind_badger_peek(inputs)
	return de_swift_kind_badger_peek(inputs)
});